<h3 mat-dialog-title >Chargement</h3>
<form>
  <div>
    <mat-spinner class ="spinner" mode="indeterminate"></mat-spinner>
  </div>
</form>
